export const DEVICE_CATALOGS_PATH = '/v2/device-catalogs' as const;
export const deviceCatalogsForSelect = {
  all: [DEVICE_CATALOGS_PATH] as const,
  catalogs: (searchText: string, genres?: readonly string[]) => [...deviceCatalogsForSelect.all, {
    searchText,
    genres: genres ?? []
  }] as const
} as const;